import { enforceResourceNameLength } from '@gonfalon/dogfood-flags/dogfood-flags';
import {
  isLength,
  isNotEmpty,
  isReservedKey,
  isValidTagList,
  validateRecord,
} from '@gonfalon/legacy-form-validation/validationUtils';

import { MAX_PROJECT_KEY_LENGTH, MAX_PROJECT_NAME_LENGTH } from '#utils/projects/constants';
import type { NewProject } from '#utils/projects/records/NewProject';
import type { Project } from '#utils/projects/records/Project';

export const validateProject = (p: Project | NewProject) =>
  validateRecord(
    p,
    isNotEmpty('name'),
    enforceResourceNameLength() ? isLength(1, MAX_PROJECT_NAME_LENGTH)('name') : () => undefined,
    isNotEmpty('key'),
    isReservedKey('key'),
    isLength(1, MAX_PROJECT_KEY_LENGTH)('key'),
    isValidTagList('tags'),
  );
